import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors, spacing, typography } from '../../theme';

export type AttendeeRsvpStatus = 'pending' | 'accepted' | 'declined' | 'tentative';

export interface AttendeeStatusBadgeProps {
  status: AttendeeRsvpStatus;
}

/**
 * Single shared badge for an attendee's RSVP status — previously duplicated
 * (with slightly different color rules) in EventDetailScreen.tsx and twice
 * in EventEditScreen.tsx. Keeps EventEditScreen's 3-color treatment
 * (accepted=success, declined=error, everything else=warning) since it
 * gives `pending`/`tentative` a distinct, informative color instead of
 * folding them into a generic gray.
 */
export const AttendeeStatusBadge: React.FC<AttendeeStatusBadgeProps> = ({ status }) => {
  const color =
    status === 'accepted' ? colors.success : status === 'declined' ? colors.error : colors.warning;
  const label = status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <View style={[styles.badge, { backgroundColor: (color as string) + '20' }]}>
      <Text style={[styles.text, { color: color as string }]}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    alignSelf: 'flex-start',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs / 2,
    borderRadius: 8,
    marginTop: spacing.xs,
  },
  text: {
    fontSize: typography.fontSize.xs,
    fontFamily: typography.fontFamily.medium,
    fontWeight: '600',
  },
});
